import { Link, useLocation } from 'react-router-dom';
import { mediaList, CATEGORY_GENRES } from '@/mocks/movies';

const categories = [
  { label: '电影', type: '电影', icon: 'ri-film-line' },
  { label: '电视剧', type: '电视剧', icon: 'ri-tv-2-line' },
  { label: '动漫', type: '动漫', icon: 'ri-ghost-2-line' },
  { label: '综艺', type: '综艺', icon: 'ri-mic-line' },
  { label: '纪录片', type: '纪录片', icon: 'ri-earth-line' },
];

export default function SideNav() {
  const location = useLocation();
  const currentType = decodeURIComponent(location.pathname.split('/')[2] || '');
  const hot = [...mediaList].sort((a, b) => b.rating - a.rating).slice(0, 3);
  const genres = currentType ? CATEGORY_GENRES[currentType] || [] : [];

  return (
    <aside className="w-full shrink-0 lg:w-56">
      <div className="lg:sticky lg:top-28 space-y-5">
        <div className="rounded-lg border border-background-200 bg-background-50 p-3">
          <p className="px-2 pb-2 text-[11px] font-medium tracking-[0.16em] text-foreground-400">栏目导航</p>
          <nav className="space-y-0.5">
            {categories.map((item) => {
              const active = currentType === item.type;
              return (
                <Link
                  key={item.type}
                  to={`/category/${encodeURIComponent(item.type)}`}
                  className={`flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm transition ${
                    active ? 'bg-primary-100 font-medium text-primary-800' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-base ${active ? 'text-primary-600' : 'text-foreground-500'}`} />
                  {item.label}
                  <i className="ri-arrow-right-s-line ml-auto w-4 h-4 flex items-center justify-center text-foreground-300" />
                </Link>
              );
            })}
            <div className="my-1.5 border-t border-background-200" />
            <Link
              to="/favorites"
              className={`flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm transition ${
                location.pathname === '/favorites' ? 'bg-secondary-100 font-medium text-secondary-900' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-heart-3-line w-4 h-4 flex items-center justify-center text-base text-secondary-600" />
              我的收藏
            </Link>
            <Link
              to="/about"
              className={`flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm transition ${
                location.pathname === '/about' ? 'bg-primary-100 font-medium text-primary-800' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line w-4 h-4 flex items-center justify-center text-base text-foreground-500" />
              关于我们
            </Link>
          </nav>
        </div>

        {genres.length > 0 && (
          <div className="rounded-lg border border-background-200 bg-background-50 p-3">
            <p className="px-2 pb-2 text-[11px] font-medium tracking-[0.16em] text-foreground-400">{currentType}题材</p>
            <div className="flex flex-wrap gap-1.5 px-1">
              {genres.filter((genre) => genre !== '全部').map((genre) => (
                <Link
                  key={genre}
                  to={`/list/${encodeURIComponent(genre)}`}
                  className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-700 transition hover:bg-primary-100 hover:text-primary-800"
                >
                  {genre}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div className="rounded-lg border border-background-200 bg-background-50 p-3">
          <p className="px-2 pb-2 text-[11px] font-medium tracking-[0.16em] text-foreground-400">评分榜</p>
          <div className="space-y-2">
            {hot.map((item, index) => (
              <Link key={item.id} to={`/detail/${item.id}`} className="flex items-center gap-2.5 rounded-md px-1.5 py-1 transition hover:bg-background-100">
                <span className="w-4 text-center font-heading text-sm font-bold text-primary-500">{index + 1}</span>
                <span className="flex-1 truncate text-xs text-foreground-800">{item.title}</span>
                <span className="text-xs font-medium text-accent-700">{item.rating.toFixed(1)}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}